import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=c25c62c6&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"
import style0 from "./Account.vue?vue&type=style&index=0&id=c25c62c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25c62c6",
  null
  
)

export default component.exports